import { AppNS } from 'app';
import { API_URL } from 'app/core/config';
import axios, { Canceler } from 'axios';

const AVATAR_URL = 'companies/avatar.json';
// const AVAILABILITY_URL = 'companies/availability.json';
// const UNAVAILABLE_PERIODS_URL = 'companies/unavailable_periods.json';
const COMPANIES_URL = 'companies.json';

const CancelToken = axios.CancelToken;
let cancel: Canceler;

export function apiSetCompanyAvatar(reqData: AppNS.Params): Promise<AppNS.Avatar> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/${AVATAR_URL}`, reqData)
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model.avatar.versions);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

export function apiSetCompanyPricingData(id: string, properties: AppNS.Params): Promise<string> {
  const reqData = {
    id,
    properties,
  };

  if (cancel !== undefined) {
    cancel();
  }
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/companies/pricing-policy.json`, reqData, {
        cancelToken: new CancelToken(function executor(c) {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
      })
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model.properties);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

// export function apiSetAvailability(
//   reqData: AppNS.Params
// ): Promise<AppNS.Params> {
//   return new Promise((resolve, reject) => {
//     axios
//       .patch(`${API_URL}/${AVAILABILITY_URL}`, reqData)
//       .then(({ data }) => {
//         if (data.model) {
//           resolve(parseAvailabilityResponseData(data.model.properties));
//         } else {
//           reject('Invalid response data');
//         }
//       })
//       .catch(reject);
//   });
// }

// export function apiSetUnavailablePeriods(
//   reqData: AppNS.Params
// ): Promise<Array<string>> {
//   return new Promise((resolve, reject) => {
//     axios
//       .patch(`${API_URL}/${UNAVAILABLE_PERIODS_URL}`, reqData)
//       .then(({ data }) => {
//         if (data.model) {
//           resolve(data.model.properties.unavailablePeriods);
//         } else {
//           reject('Invalid response data');
//         }
//       })
//       .catch(reject);
//   });
// }

export function setCompany(reqData: AppNS.Params): Promise<AppNS.CompanyDetails> {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/${COMPANIES_URL}`, reqData)
      .then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

export function getCompanies(): Promise<AppNS.CompanyDetails[]> {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/${COMPANIES_URL}`)
      .then(({ data }) => {
        if (data.results) {
          resolve(data.results);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

export function updateCompany(reqData: AppNS.Params): Promise<AppNS.Company> {
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/${COMPANIES_URL}`, reqData)
      .then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}
